import { Observable } from 'rxjs';
import { Service } from './model';
import { ApiResponse } from '../common/api-response';

export abstract class ServiceRepository {
  abstract createService(service: Partial<Service>): Observable<ApiResponse<Service>>;
  abstract getService(id: number): Observable<ApiResponse<Service>>;
  abstract getServices(page: number, limit: number, query?: string): Observable<ApiResponse<Service[]>>;
  abstract updateService(id: number, service: Partial<Service>): Observable<ApiResponse<Service>>;
  abstract deleteService(id: number): Observable<ApiResponse<void>>;

  abstract createServiceSale(data: any): Observable<ApiResponse<any>>;
  abstract getServiceInvoices(page: number, limit: number, status?: string, date_from?: string, date_to?: string): Observable<ApiResponse<any>>;
  abstract getServiceConflicts(page: number, limit: number): Observable<ApiResponse<any>>;
  abstract resolveServiceConflict(bill_id: number, force_generate: boolean): Observable<ApiResponse<any>>;
}
